import React from 'react'
import { Box } from '@mui/material';
import GuestTopbar from '../components/admin/topbar/GuestTopbar';

const GuestLayout = ({ children }: { children: React.ReactNode }) => {
    console.log('GuestLayout Rendered');
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', minHeight: '100vh', height: 'auto', position: 'relative', minWidth: '290px', overflow: 'hidden' }}>
            <GuestTopbar />
            <Box sx={{ width: '100%', flex: '1 1', display: 'flex', mt: { xs: '75px', sm: '80px' } }}>
                <Box sx={{ flexGrow: 1, borderRightWidth: 1, borderRightStyle: 'solid', borderRightColor: 'grey.400' }}>
                    <Box sx={{ position: 'relative', minHeight: '100%' }}>
                        {children}
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

export default GuestLayout;